export default __webpack_public_path__ + "static/media/JOSA CLASS-9_SYLLABUS_2025-26.d58d85e9.pdf";